import { render, staticRenderFns } from "./teachers.vue?vue&type=template&id=676256b2&scoped=true&"
import script from "./teachers.vue?vue&type=script&lang=js&"
export * from "./teachers.vue?vue&type=script&lang=js&"
import style0 from "./teachers.vue?vue&type=style&index=0&id=676256b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676256b2",
  null
  
)

export default component.exports